import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { PeerFeedbackTemplateFragmentDoc } from '../../fragments/generated/FeedbackTemplate';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GetFeedbackTemplatesQueryVariables = Types.Exact<{
  sort?: Types.InputMaybe<Array<Types.SortType> | Types.SortType>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Float']['input']>;
  filters?: Types.InputMaybe<Types.PeerFeedbackTemplatesFilters>;
}>;


export type GetFeedbackTemplatesQuery = { peerFeedbackTemplates?: { success: boolean, errorCode?: Types.PaginationErrorCodeEnum | null, totalCount: number, pageInfo?: { hasNextPage?: boolean | null, endCursor?: string | null } | null, edges?: Array<{ node: { id: string, name: string, templates: Array<{ text: string }> } }> | null } | null };


export const GetFeedbackTemplatesDocument = /*#__PURE__*/ gql`
    query getFeedbackTemplates($sort: [SortType!], $after: String, $first: Float, $filters: PeerFeedbackTemplatesFilters) {
  peerFeedbackTemplates(
    sort: $sort
    after: $after
    first: $first
    filters: $filters
  ) {
    pageInfo {
      hasNextPage
      endCursor
    }
    success
    errorCode
    totalCount
    edges {
      node {
        ...PeerFeedbackTemplate
      }
    }
  }
}
    ${PeerFeedbackTemplateFragmentDoc}`;

export function useGetFeedbackTemplatesQuery(options?: Omit<Urql.UseQueryArgs<GetFeedbackTemplatesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetFeedbackTemplatesQuery, GetFeedbackTemplatesQueryVariables>({ query: GetFeedbackTemplatesDocument, ...options });
};